<div class="pharmacyPage cardPage">
  <div class="pharmacy_header">
    <div class="container header_container">
      <h2>My Cards</h2>
      <div class="right_btn_sec">
        <!-- <div class="map_btn">
          <i></i>
          Locate on Map
          <input type="checkbox" id="locate" (click)="Showmapview()" />
          <label for="locate">
            <i></i>
          </label>
        </div> -->
        <!-- <div class="sortby" (click)="sortbyddl = !sortbyddl">
          Sort By
          <i></i>
          
        </div> -->
        <div class="sortby_ddl" [hidden]="!sortbyddl">
          <ul *ngIf="IsDistancesort">
            <li (click)="SortcardsList('Distance')">Distance</li>
            <li (click)="SortcardsList('Price')" class="active">Price</li>
          </ul>
          <ul *ngIf="IsPricesort">
              <li (click)="SortcardsList('Distance')">Distance</li>
              <li (click)="SortcardsList('Price')" class="active">Price</li>
            </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="container" id="pharmacy_container">
    <div class="pharmacy_box">
      <div class="pharmacy_list">
<!-- ---------------------Sample Card-------------------------- -->
          <div class="card" (click)="SampleDiscountcard()">
              <div class="name_Sec">
                <p>Can't find your medication?</p>
                <span>$</span>
              </div>
              <div class="distance">Use this card and save now!</div>
              <div class="distance"></div>
            </div>

        <div class="card" *ngFor="let item of CardsList"  (click)="showDiscountcard(item)">
          <div class="name_Sec">
            <p>{{item.DrugName}}</p>
            <span>${{item.Price}}</span>
          </div>
          <div class="distance">{{item.Quantity}} {{item.Form}} {{item.Dose}}</div>
          <div class="distance">{{item.PharmacyName}}</div>
        </div>
      </div>
      <!-- <div class="maps_box" *ngIf="mapview">mapview</div> -->
    </div>
  </div>
  <!-- Discount Card -->
  <div class="discount_card" *ngIf="showcard" id="print-section">
    <div class="close_search_pharmacy_popup" (click)="CloseDrugDetails()"></div>
    <div class="discount_card_parent">
      <div class="header">
        <img src="../../assets/images/logo.png" alt="" />
        <div class="button_sec">
          <!-- <div class="sendsms">Send SMS</div> -->
          <div class="saved" (click)="RemoveCard()">Remove</div>
          <div class="print" (click)="PrintMe()">Print</div>
        </div>
      </div>
      <div class="logoarea" *ngIf="Card_Pharmacy_Logo">
        <div class="singlecare">
          <img src="../../assets/images/singlecare.svg" alt="">
        </div>
        <div class="walmart_img" *ngIf="RXS_Walmart">
          <span>Available at</span>
          <img src="http://rxhacker.23byt.es/MailSnap/wallmart.svg" alt="">
        </div>
        <div class="cvs_img" *ngIf="RXS_CVS">
            <span>For exclusive use at</span>
            <img src="http://rxhacker.23byt.es/MailSnap/cvs.svg" alt="">
          </div>
      </div>
      <div class="pharmacybox">
        <div class="name_quantity">
          <p>{{Card_DrugName}}</p>
          <span>{{Card_Quantity}} {{Card_DrugForm}} | {{Card_Dosage}}</span>
        </div>
        <div class="price">${{PharmacyPrice}}</div>
      </div>
      <div class="pharmacyDetail">
        <p class="notInsurance">This card is free. <strong>This is not insurance.</strong></p>
        <div class="name">
         {{SelectPharmacy}}
        </div>
        <div class="address">{{PAddress2}}</div>
        <div class="number">{{PharmacyPhone}}</div>
        <div class="method_salt">
          <div class="method">
            <div>bin</div>
            <div>{{RXBin}}</div>
          </div>
          <div class="method">
            <div>PCN</div>
            <div>{{RXCPN}}</div>
          </div>
          <div class="method">
            <div>Member ID</div>
            <div>{{MemberId}}</div>
          </div>
          <div class="method">
            <div>Group</div>
            <div>{{GroupNumber}}</div>
          </div>
        </div>
        <div class="email_field">
            <input type="email" id="email" name="ShareEmail" placeholder=" " autocomplete="off" [(ngModel)]="UserInputEmail" (click)="ClearMessage($event)" (keypress)="clearClassMsg()"  (blur)="clearClassMsg()"/>
          <label for="email">Enter your e-mail</label>
          <div class="sendbtn"(click)="ShareDiscountCard()">Send</div>
          <div class="loadProcess"></div>
        </div>
        <span>{{SendDiscountMessage}}</span>
        <div class="helpline_btn">
          <div class="helpline" (click)="PharmacyHelpLine()"><a href="tel:{{ PharmacistHelpline }}">{{PharmacistHelpline}}</a></div>
          <div class="direction" (click)=RedirectGoogleDirection()>
            Get Directions
            <img src="../../assets/images/direction.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="discount_card" *ngIf="SampleDiscountCard">
      <div class="close_search_pharmacy_popup" (click)="CloseDrugDetails()"></div>
      <div class="discount_card_parent">
        <div class="header">
          <img src="../../assets/images/logo.png" alt="" />
          <div class="button_sec">
            <!-- <div class="sendsms">Send SMS</div> -->
            <!-- <div class="saved" (click)="RemoveCard()">Remove</div>
            <div class="print" (click)="PrintMe()">Print</div> -->
          </div>
        </div>
      
        <div class="pharmacybox">
          <div class="name_quantity">
            <p>{{TopText}}</p>
            <span>- - | -</span>
          </div>
          <div class="price">$</div>
        </div>
        <div class="pharmacyDetail">
          <p class="notInsurance">This card is free. <strong>This is not insurance.</strong></p>
          <div class="name">
            {{HeadingText}}
          </div>
            <div class="address">{{PAddress2}}</div>
            <div class="number">{{PharmacyPhone}}</div>
          <div class="method_salt">
            <div class="method">
              <div>bin</div>
              <div>{{RXBin}}</div>
            </div>
            <div class="method">
              <div>PCN</div>
              <div>{{RXCPN}}</div>
            </div>
            <div class="method">
              <div>Member ID</div>
              <div>{{MemberId}}</div>
            </div>
            <div class="method">
              <div>Group</div>
              <div>{{GroupNumber}}</div>
            </div>
          </div>
          <!-- <div class="email_field">
            <input type="email" id="email" name="ShareEmail" placeholder=" " [(ngModel)]="UserInputEmail" (click)="ClearMessage($event)"/>
            <label for="email">Enter your e-mail</label>
            <div class="sendbtn"(click)="ShareDiscountCard()">Send</div>
          </div> -->
          <!-- <span>{{SendDiscountMessage}}</span> -->
          <div class="helpline_btn">
            <!-- <div class="helpline" (click)="PharmacyHelpLine()">{{PharmacistHelpline}}</div> -->
            <!-- <div class="direction" (click)=RedirectGoogleDirection()>
              Get Directions
              <img src="../../assets/images/direction.svg" alt="" />
            </div> -->
          </div>
        </div>
      </div>
    </div>
</div>
